<template>
  <div class="page-not-found">
    <div class="fr-container">
      <div class="fr-grid-row">
        <div class="fr-col">
          <h1>Page non trouvée</h1>
          <p>Cette page n'existe pas.</p>
          <p><a href="#/" class="fr-link fr-icon-arrow-left-line fr-link--icon-left" target="_self">Retourner à l'accueil</a></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'page-not-found',
    props: {
    },
    data: () => ({
    }),
    methods: {
    }
  }
</script>